import { JSX, useContext, useEffect, useRef } from "react";
import { InteractionEvent, Popup } from "mapbox-gl";
import { CompetitiveInsightsMapContext } from "@app/overviews/network-benchmarking-dashboard/filters/CompetitiveInsightsMapContext";
import { BenchmarkingNetworkType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/benchmarkingNetworkType";

interface CompetitiveInsightsPopupWrapperProps {
  buildTooltipContent: (e: InteractionEvent, showTable?: boolean) => void;
  children: JSX.Element;
  layerId: string;
  selectedNetworks: BenchmarkingNetworkType[];
  showTable?: boolean;
}

const CompetitiveInsightsPopupWrapper = (props: CompetitiveInsightsPopupWrapperProps): JSX.Element => {
  const competitiveInsightsMapContext = useContext(CompetitiveInsightsMapContext);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    buildPopup();
  }, []);

  useEffect(() => {
    buildPopup();
  }, [props.selectedNetworks]);

  const buildPopup = (): void => {
    const map = competitiveInsightsMapContext.mapRef.current?.getMap();
    const interactions = map._interactions.interactionsByType.get("mousemove");

    if (!!interactions) {
      const existingInteraction = interactions.get("hover-tooltip" + props.layerId)

      if (!!existingInteraction) {
        map.removeInteraction("hover-tooltip" + props.layerId);
      }
    }

    const popup: Popup = new Popup({
      closeButton: false,
      closeOnClick: false,
      maxWidth: "auto",
      offset: [0, -20]
    });

    map.addInteraction("hover-tooltip" + props.layerId, {
      handler: (e) => {
        props.buildTooltipContent(e, props.showTable);

        popup
          .setLngLat(e.lngLat)
          .setDOMContent(popupRef.current)
          .addTo(map);
      },
      target: { layerId: props.layerId },
      type: "mousemove",
    });

    map.on("mouseleave", props.layerId, () => {
      popup.remove();
    });
  }

  return (
    <div className="d-none">
      <div ref={popupRef}>
        {props.children}
      </div>
    </div>
  );
};

export default CompetitiveInsightsPopupWrapper;
